import { FC } from 'react';
import { MedusaLineItem } from 'lib/home/generated/types/api';
import { MealImage } from 'lib/ui-components/src';

interface CartItemProps {
  item: MedusaLineItem;
  className?: string;
  index: number;
}

export const CartItem: FC<CartItemProps> = ({ item, index }) => {
  const { title, thumbnail, quantity } = item;
  const itemCollection = item.variant.product.collection.title;

  return (
    <div className="cart-item flex" data-cy={`cart-item-${itemCollection}-${index}`}>
      <div className="cart-item__thumbnail w-[96px] h-[96px] mr-3 flex-none">
        <MealImage
          className="block max-w-none w-full h-full object-contain object-center"
          url={thumbnail}
          title={title}
        />
      </div>
      <div className="flex-1">
        <div className="cart-item__title mt-3">{title}</div>
        {/* TODO: We need to consider refactoring our theme colors to bring them into greater alignment with the designs. */}
        {quantity > 1 && (
          <div className="cart-item__quantity text-sm mt-2 text-brand-cool-gray-400">QTY: {quantity}</div>
        )}
      </div>
    </div>
  );
};
